import { useState } from 'react'
import mixpanel from 'mixpanel-browser'

import { DiscoveryDialog } from 'src/components/Dialogs/DiscoveryAssets/DiscoveryDialog'
import { DiscoveryLmnDialog } from 'src/components/Dialogs/DiscoveryAssets/DiscoveryLmnDialog'
import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { CDN_PATH } from 'src/constants/global'
import styles from './Tagline.scss'

interface TaglineProps {
  align?: string
  allBlack?: boolean
  allWhite?: boolean
  openEventName?: string
  textColor?: string
  unsetStyles?: boolean
  isLmn?: false
  merchantUuid?: string
}
interface LmnTaglineProps {
  align?: string
  allBlack?: boolean
  allWhite?: boolean
  openEventName?: string
  textColor?: string
  unsetStyles?: boolean
  isLmn: true
  merchantUuid: string
}

type AllTaglineProps = TaglineProps | LmnTaglineProps

const Tagline = ({
  align,
  allBlack,
  allWhite,
  openEventName,
  textColor,
  unsetStyles,
  isLmn,
  merchantUuid,
}: AllTaglineProps): JSX.Element => {
  const { palette } = useTheme()
  const [open, setOpen] = useState(false)
  const [openLmn, setOpenLmn] = useState(false)
  const handleOpen = (): void => {
    if (openEventName) {
      mixpanel.track(openEventName)
    }
    setOpen(true)
  }
  const handleOpenLmn = (): void => {
    if (openEventName) {
      mixpanel.track(openEventName)
    }
    if (isLmn) {
      setOpenLmn(true)
    }
  }
  const handleClose = (): void => setOpen(false)
  const handleCloseLmn = (): void => setOpenLmn(false)

  return (
    <>
      <Box display="flex" justifyContent={align ?? 'left'}>
        <Box
          className={styles.sikaTagline}
          color={allWhite ? 'white' : (textColor ?? palette.primary.main)}
          onClick={isLmn ? handleOpenLmn : handleOpen}
        >
          { isLmn ? (
            <Typography
              className={styles.sikaTaglineText}
              variant={unsetStyles ? 'body3UnsetFont' : 'body3'}
            >
              Using your HSA or FSA?
              <span>&nbsp;</span>
              {/* <Link
                margin="0px 4px"
                color="inherit"
                variant="inherit"
                fontWeight="medium"
              > */}
              Request an LMN
              {' '}
              {' '}
              {/* </Link> */}
              then checkout with
            </Typography>
          ) : (
            <Typography
              className={styles.sikaTaglineText}
              variant={unsetStyles ? 'body3UnsetFont' : 'body3'}
            >
              Use your HSA or FSA when you check out with
            </Typography>
          )}
          { allBlack && !allWhite ? (
            <img src={`${CDN_PATH}/images/sika-logo-black.svg`} alt="Sika" className={styles.sikaTaglineSikaIconBlack} />
          ) : (
            <img src={`${CDN_PATH}/images/sika-logo-green-background.svg`} alt="Sika" className={styles.sikaTaglineSikaIcon} />
          )}
          <InfoOutlinedIcon className={styles.sikaTaglineInfoIcon} fontSize="inherit" />
        </Box>
      </Box>
      <DiscoveryDialog isOpen={open} onClose={handleClose} />
      <DiscoveryLmnDialog isOpen={openLmn} onClose={handleCloseLmn} merchantUuid={merchantUuid ?? ''} />
    </>
  )
}

export default Tagline
